import { Link, useRouterState } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AnalyticsIcon, WarningCircleIcon, LightBulbIcon } from "@inthememory/spectra-ui-icons";

import { useAuth } from "@/hooks/useAuth";
import { analyticsPages } from "@/lib/analytics-pages";
import type { ReactNode } from "react";

type NavLinkDef = {
  titleKey: string;
  href: string;
  icon: ReactNode;
  permission?: string;
};

const navLinks: NavLinkDef[] = [
  {
    titleKey: "nav.analytics",
    href: analyticsPages.onShelfAvailability.path,
    icon: <AnalyticsIcon className="h-4 w-4" />,
    permission: "analytics:view",
  },
  {
    titleKey: "nav.incidents",
    href: "/incidents",
    icon: <WarningCircleIcon className="h-4 w-4" />,
    permission: "incidents:view",
  },
  {
    titleKey: "nav.opportunities",
    href: "/opportunities",
    icon: <LightBulbIcon className="h-4 w-4" />,
    permission: "opportunities:view",
  },
];

export function NavLinks() {
  const { t } = useTranslation();
  const routerState = useRouterState();
  const currentPath = routerState.location.pathname;
  const { user } = useAuth();
  const permissions = user?.permissions ?? [];

  const visibleLinks = navLinks.filter(
    (link) => !link.permission || permissions.includes(link.permission),
  );

  return (
    <div className="flex items-center gap-1">
      {visibleLinks.map((link) => {
        const isActive = currentPath.startsWith(link.href);
        return (
          <Link key={link.href} to={link.href} className="no-underline">
            <span
              className={`flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? "bg-slate-900 text-white"
                  : "text-slate-700 hover:bg-slate-50"
              }`}
            >
              {link.icon}
              {t(link.titleKey)}
            </span>
          </Link>
        );
      })}
    </div>
  );
}
